import { enhance } from './enhancers';
import { UpcomingGameButton } from './component';

export default enhance(UpcomingGameButton);
